import {InjectionToken} from '@angular/core';
import * as LANG_DE_TRANS from './lang-de.json';
import * as LANG_EN_TRANS from './lang-en.json';

export const TRANSLATIONS = new InjectionToken('translations');

export const dictionary = {
    ['de']: JSON.parse(JSON.stringify(LANG_DE_TRANS)),
    ['en']: JSON.parse(JSON.stringify(LANG_EN_TRANS)),
};

export const TRANSLATION_PROVIDERS = [
    {provide: TRANSLATIONS, useValue: dictionary},
];
